module.exports = __webpack_public_path__ + "static/media/success-toast-status.1b94ec09.svg";